// Template for Contentful "Project" content type
import React from 'react';
import Helmet from 'react-helmet';
import { graphql } from 'gatsby';
import styled from 'react-emotion';
import Timeago from 'react-timeago';
import EntryType from '../components/entry-type';
import Layout from '../components/layout';

const comparePublishDate = (a, b) => {
  a = new Date(a.publishDate);
  b = new Date(b.publishDate);
  return (a - b) * -1;
};

const ProjectTemplate = ({ data, location }) => {
  const project = data.contentfulProject;
  project.entries = project.entries.filter(entry => !!entry.publishDate);
  project.entries = project.entries.sort(comparePublishDate);
  return (
    <Layout location={location}>
      <Wrapper>
        <Helmet title={`${project.name} | Changelog`} />
        <ProjectName>{project.name} Changelog</ProjectName>
        <ProjectMeta>
          <a href={project.url} target="_blank" rel="noopener noreferrer">
            {project.url}
          </a>
        </ProjectMeta>
        {project.entries.map(entry => (
          <ChangelogEntry key={entry.id}>
            <h2>{entry.title}</h2>
            <TimeagoWrapper>
              <Timeago date={entry.publishDate} />
            </TimeagoWrapper>
            <EntryMeta>
              <EntryType type={entry.type}>{entry.type}</EntryType>
            </EntryMeta>
            <EntryContent>
              <div
                dangerouslySetInnerHTML={{
                  __html: entry.content.childMarkdownRemark.html,
                }}
              />
            </EntryContent>
          </ChangelogEntry>
        ))}
      </Wrapper>
    </Layout>
  );
};

export default ProjectTemplate;

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 560px;
  margin: 0 auto;
`;

const ProjectName = styled('h1')`
  margin-bottom: 10px;
  text-align: center;
`;

const ProjectMeta = styled('div')`
  text-align: center;

  a {
    color: #9ea3ad;
    font-size: 14px;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    &:hover {
      border-bottom: 1px solid #9ea3ad;
    }
  }
`;

const ChangelogEntry = styled('div')`
  padding: 25px 0;
  border-bottom: 1px solid #f3f3f3;
  width: 560px;
  position: relative;

  h2 {
    font-size: 1.55rem;
    font-weight: 500;
    line-height: 1.9rem;
    min-height: 35px;
    padding: 0;
    margin: 0;
  }
`;

const TimeagoWrapper = styled('div')`
  position: absolute;
  top: 30px;
  left: -130px;
  font-size: 0.9rem;
  opacity: 1;
  width: 120px;
  line-height: 1.45;
  transition: opacity 0.3s ease;
`;

const EntryMeta = styled('div')`
  margin: 5px 0 15px;
  display: flex;
`;

const EntryContent = styled('div')`
  line-height: 1.55rem;
  min-height: 40px;
  clear: both;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  -webkint-font-smoothing: antialiased;
`;

export const pageQuery = graphql`
  query ProjectQuery($slug: String!) {
    contentfulProject(slug: { eq: $slug }) {
      id
      name
      slug
      url
      entries {
        id
        title
        publishDate
        updatedAt
        type
        content {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
`;
